/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [无数据商品放行退还,并打印无数据包裹号↗](http://yapi.yishou.com/project/128/interface/api/33511) 的 **请求配置**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/makeNoDataPackageBackToSupply`
 * @更新时间 `2022-05-09 09:33:35`
 */
const makeNoDataPackageBackToSupplyRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/makeNoDataPackageBackToSupply",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["ndgid"],
        properties: { ndgid: { type: "string", description: "多个无数据id 逗号隔开" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            qr_code: {
                type: "string",
                description: '"https://img4.yishouapp.com/obs/noDataGoodsService/202205/09/165205994162786f2545f23.png"',
            },
            pgname: { type: "string", description: '"继明广州采购组"' },
            no_data_package_no: { type: "string", description: '"FXTH202205090001"' },
            supply_name: { type: "string", description: '"3-3街-99999-㺵㺵不能忘怀LUNGLUNGLUNGLU"' },
            tool_num: { type: "string", description: '"共2件"' },
        },
        additionalProperties: false,
    },
    requestFunctionName: "makeNoDataPackageBackToSupply",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [无数据商品放行退还,并打印无数据包裹号↗](http://yapi.yishou.com/project/128/interface/api/33511) 的 **请求函数**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/makeNoDataPackageBackToSupply`
 * @更新时间 `2022-05-09 09:33:35`
 */
export const makeNoDataPackageBackToSupply = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(makeNoDataPackageBackToSupplyRequestConfig, requestData), ...args);
};
makeNoDataPackageBackToSupply.requestConfig = makeNoDataPackageBackToSupplyRequestConfig;
/**
 * 接口 [撤销包裹号↗](http://yapi.yishou.com/project/128/interface/api/33512) 的 **请求配置**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/cloneNoDataPackageByPackageNo`
 * @更新时间 `2022-05-05 17:51:38`
 */
const cloneNoDataPackageByPackageNoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/cloneNoDataPackageByPackageNo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["noDataPackageNo"],
        properties: { noDataPackageNo: { type: "string", description: "无数据包裹号" } },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "cloneNoDataPackageByPackageNo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [撤销包裹号↗](http://yapi.yishou.com/project/128/interface/api/33512) 的 **请求函数**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/cloneNoDataPackageByPackageNo`
 * @更新时间 `2022-05-05 17:51:38`
 */
export const cloneNoDataPackageByPackageNo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(cloneNoDataPackageByPackageNoRequestConfig, requestData), ...args);
};
cloneNoDataPackageByPackageNo.requestConfig = cloneNoDataPackageByPackageNoRequestConfig;
/**
 * 接口 [根据无数据id获取详情↗](http://yapi.yishou.com/project/128/interface/api/33513) 的 **请求配置**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/getNoDataInfoByNdgid`
 * @更新时间 `2022-05-05 17:52:01`
 */
const getNoDataInfoByNdgidRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/getNoDataInfoByNdgid",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["ndgid", "supplyId"],
        properties: {
            ndgid: { type: "string", description: "无数据打标id" },
            supplyId: { type: "string", description: "默认=0.传入supply_id会做校验" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            result: { type: "boolean", description: "true" },
            msg: { type: "string" },
            data: {
                type: "object",
                properties: {
                    supplyInfo: {
                        type: "object",
                        properties: {
                            supply_id: { type: "string", description: '"72651"' },
                            supply_name: { type: "string", description: '"3-3街-99999-㺵㺵不能忘怀LUNGLUNGLUNGLU"' },
                        },
                        additionalProperties: false,
                    },
                    noDataInfo: {
                        type: "object",
                        properties: {
                            ndgid: { type: "string", description: '"273096"' },
                            pici_no: { type: "string" },
                            package_no: { type: "string" },
                            img: { type: "null" },
                            supply_id: { type: "string", description: '"72651"' },
                            supply_name: { type: "string", description: '"3-3街-99999-㺵㺵不能忘怀LUNGLUNGLUNGLU"' },
                            goods_name: { type: "string", description: '"无数据商品-继明广州采购组"' },
                            co_val: { type: "string" },
                            si_val: { type: "string" },
                            no_data_reason: { type: "string", description: '"3"' },
                            da_biao_time: { type: "string", description: '"2022-04-18 14:41"' },
                        },
                        additionalProperties: false,
                    },
                },
                additionalProperties: false,
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getNoDataInfoByNdgid",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [根据无数据id获取详情↗](http://yapi.yishou.com/project/128/interface/api/33513) 的 **请求函数**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/getNoDataInfoByNdgid`
 * @更新时间 `2022-05-05 17:52:01`
 */
export const getNoDataInfoByNdgid = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getNoDataInfoByNdgidRequestConfig, requestData), ...args);
};
getNoDataInfoByNdgid.requestConfig = getNoDataInfoByNdgidRequestConfig;
/**
 * 接口 [根据无数据包裹号获取内容↗](http://yapi.yishou.com/project/128/interface/api/33514) 的 **请求配置**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /open/Goods/getNoDataPackageInfoByPackageNo`
 * @更新时间 `2022-05-07 10:48:58`
 */
const getNoDataPackageInfoByPackageNoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/open/Goods/getNoDataPackageInfoByPackageNo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["noDataPackageNo"],
        properties: { noDataPackageNo: { type: "string", description: "无数据包裹号" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            supplyInfo: {
                type: "object",
                properties: {
                    supply_name: { type: "string", description: '"3-3街-99999-㺵㺵不能忘怀LUNGLUNGLUNGLU"' },
                    supply_id: { type: "string", description: '"72651"' },
                },
                additionalProperties: false,
            },
            noDataPackageNum: { type: "integer", description: "1" },
            noDataList: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: '"4"' },
                        no_data_package_no: { type: "string", description: '"FXTH202205030002"' },
                        ndgid: { type: "string", description: '"273096"' },
                        signing_time: { type: "string", description: '"0"' },
                        signing_name: { type: "string" },
                        status: { type: "string", description: '"1"' },
                        created_at: { type: "string", description: '"2022-05-03 10:27:37"' },
                        updated_at: { type: "string", description: '"2022-05-03 10:27:37"' },
                        supply_id: { type: "string", description: '"72651"' },
                        handle_state: { type: "string", description: '"3"' },
                        pgname: { type: "string", description: '"继明广州采购组"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"id":"4","no_data_package_no":"FXTH202205030002","ndgid":"273096","signing_time":"0","signing_name":"","status":"1","created_at":"2022-05-03 10:27:37","updated_at":"2022-05-03 10:27:37","supply_id":"72651","handle_state":"3","pgname":"继明广州采购组"}]',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getNoDataPackageInfoByPackageNo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [根据无数据包裹号获取内容↗](http://yapi.yishou.com/project/128/interface/api/33514) 的 **请求函数**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /open/Goods/getNoDataPackageInfoByPackageNo`
 * @更新时间 `2022-05-07 10:48:58`
 */
export const getNoDataPackageInfoByPackageNo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getNoDataPackageInfoByPackageNoRequestConfig, requestData), ...args);
};
getNoDataPackageInfoByPackageNo.requestConfig = getNoDataPackageInfoByPackageNoRequestConfig;
/**
 * 接口 [签收无数据包裹号↗](http://yapi.yishou.com/project/128/interface/api/33515) 的 **请求配置**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /open/Goods/signNoDataPackageByPackageNo`
 * @更新时间 `2022-05-09 11:47:24`
 */
const signNoDataPackageByPackageNoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/open/Goods/signNoDataPackageByPackageNo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["noDataPackageNo", "signingName"],
        properties: {
            noDataPackageNo: { type: "string", description: "包裹号" },
            signingName: { type: "string", description: "签收人" },
        },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "signNoDataPackageByPackageNo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [签收无数据包裹号↗](http://yapi.yishou.com/project/128/interface/api/33515) 的 **请求函数**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /open/Goods/signNoDataPackageByPackageNo`
 * @更新时间 `2022-05-09 11:47:24`
 */
export const signNoDataPackageByPackageNo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(signNoDataPackageByPackageNoRequestConfig, requestData), ...args);
};
signNoDataPackageByPackageNo.requestConfig = signNoDataPackageByPackageNoRequestConfig;
/**
 * 接口 [获取驻点打印小程序二维码↗](http://yapi.yishou.com/project/128/interface/api/33543) 的 **请求配置**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackageScanPage`
 * @更新时间 `2022-05-09 17:08:54`
 */
const getNoDataPackageScanPageRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/getNoDataPackageScanPage",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["formCache"],
        properties: { formCache: { type: "string", description: "是否重新获取:1=否 0=是 （默认拿缓存记好了的）" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            result: { type: "boolean", description: "true" },
            msg: { type: "string" },
            qrCode: {
                type: "string",
                description: '"https://img4.yishouapp.com/obs/getMiniNoDataPackageScanPage/202205/09/16520863396278d6439ccbb.png"',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getNoDataPackageScanPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取驻点打印小程序二维码↗](http://yapi.yishou.com/project/128/interface/api/33543) 的 **请求函数**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackageScanPage`
 * @更新时间 `2022-05-09 17:08:54`
 */
export const getNoDataPackageScanPage = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getNoDataPackageScanPageRequestConfig, requestData), ...args);
};
getNoDataPackageScanPage.requestConfig = getNoDataPackageScanPageRequestConfig;
/**
 * 接口 [获取无数据包裹打印面单↗](http://yapi.yishou.com/project/128/interface/api/33544) 的 **请求配置**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackagePrintInfo`
 * @更新时间 `2022-05-09 17:12:05`
 */
const getNoDataPackagePrintInfoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/NoDataGoods/getNoDataPackagePrintInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["noDataPackageNo"],
        properties: { noDataPackageNo: { type: "string", description: "无数据包裹号" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            qr_code: {
                type: "string",
                description: '"https://img4.yishouapp.com/obs/noDataGoodsService/202205/09/165207172462789d2cd1afe.png"',
            },
            pgname: { type: "string", description: '"继明广州采购组"' },
            no_data_package_no: { type: "string", description: '"FXTH202205060003"' },
            supply_name: { type: "string", description: '"3-3街-99999-㺵㺵不能忘怀LUNGLUNGLUNGLU"' },
            tool_num: { type: "string", description: '"共1件"' },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getNoDataPackagePrintInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取无数据包裹打印面单↗](http://yapi.yishou.com/project/128/interface/api/33544) 的 **请求函数**
 *
 * @分类 [无数据包裹↗](http://yapi.yishou.com/project/128/interface/api/cat_3152)
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackagePrintInfo`
 * @更新时间 `2022-05-09 17:12:05`
 */
export const getNoDataPackagePrintInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getNoDataPackagePrintInfoRequestConfig, requestData), ...args);
};
getNoDataPackagePrintInfo.requestConfig = getNoDataPackagePrintInfoRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/noDataPackage.js